/* eslint-disable array-bracket-newline */
export const handleNoneEmptyFolders = (snippets = [], folders = []) => {
  const snippetsFoldersIds = [
    ...new Set(snippets.map((snippet) => snippet.folder?.id)),
  ];

  const uniqueFolders = new Map();
  for (const folder of folders) {
    if (snippetsFoldersIds.includes(folder.id)) {
      uniqueFolders.set(folder.id, folder);
    }
  }
  return [...uniqueFolders.values()];
};

export const emptyFolders = (snippetsState, foldersState) => {
  const snippetsFoldersIds = [
    ...new Set(snippetsState.map((snippet) => snippet.folder?.id)),
  ];

  const uniqueFolders = new Map();
  for (const folder of foldersState) {
    if (!snippetsFoldersIds.includes(folder.id)) {
      uniqueFolders.set(folder.id, folder);
    }
  }
  return [...uniqueFolders.values()];
};
